<template>
  <video-player ref="videoPlayer" :playsinline="true" :options="playerOptions" @play="" @pause="">
  </video-player>

</template>

<style scoped>

</style>

<script>
  import GhVideo from "./ghVideo.ts";
  export default GhVideo;
</script>